export default __webpack_public_path__ + "static/media/icon-check-white.142384d7.svg";